// Load payroll settings route module for Vuex resource registrations (netPaySettings, adjustment codes, statutory deductions, etc.).
import '@/modules/payroll/registerPayrollStoreResources'
import store from '@/store'
import PayrollLayout from './PayrollLayout.vue'
import { getPayrollIndexRoute } from '@/router/sectionRouteUtils'

export default {
  name: 'payroll',
  label: 'Payroll',
  link: 'payroll',
  path: 'payroll',
  props: true,
  icon: 'money-check-dollar',
  description: 'View and generate pay runs.',
  component: PayrollLayout,
  requirePerm: 'manage_payroll',
  requireFeature: 'pay_run',
  require: (state, getters) => getters.payRunEnabled || getters.netPayEnabled || state.permissions.includes('edit_settings'),
  breadcrumbLeaf: true,
  children: [
    {
      name: 'pay-run-list',
      navIcon: 'Banknote',
      description: 'Generate and review pay runs.',
      label: 'Pay Runs',
      path: 'runs/:view?',
      requireGetter: 'payRunEnabled',
      component: () => import('./PayRunList.vue'),
      children: [
        {
          name: 'pay-summary-detail',
          path: 'summaries/:paySummaryId',
          component: () => import('./PaySummaryDetail.vue'),
        }
      ]
    },
    {
      name: 'net-pay-adjustment-list',
      navLabel: 'Net Pay Adjustments',
      navIcon: 'Receipt',
      description: 'One-off additions and deductions to net pay.',
      label: 'Adjustments',
      path: 'netpay/adjustments/:view?',
      requireGetter: 'netPayEnabled',
      component: () => import('./adjustment/NetPayAdjustmentList.vue')
    },
    {
      name: 'payroll-settings',
      label: 'Settings',
      icon: 'cog',
      title: 'Payroll Settings',
      path: 'settings',
      beforeEnter: to => {
        if (to.name === 'payroll-settings') {
          return { name: 'payroll-defaults', params: to.params, query: to.query, hash: to.hash }
        }
        return true
      },
      requirePerm: 'edit_settings',
      component: () => import('@/components/TabPanel.vue'),
      children: [
        {
          name: 'payroll-defaults',
          navIcon: 'SlidersHorizontal',
          label: 'Defaults',
          icon: 'sliders',
          title: 'Payroll Defaults',
          path: 'defaults',
          component: () => import('@/modules/payroll/PayrollDefaultsForm.vue')
        },
        {
          name: 'payclass-list',
          navIcon: 'Layers',
          label: 'Pay Classes',
          icon: 'users',
          path: 'classes/:view?',
          props: true,
          requireGetter: 'payrollEnabled',
          component: () => import('@/modules/payroll/PayClassList.vue')
        },
        {
          name: 'payroll-paycodes',
          navIcon: 'Tags',
          label: 'Pay Codes',
          icon: 'tags',
          path: 'payCodes',
          requireGetter: 'payrollEnabled',
          component: () => import('@/modules/payroll/PayCodeList.vue')
        },
        {
          name: 'payroll-rules',
          navIcon: 'Scale',
          label: 'Rules',
          icon: 'scale-balanced',
          title: 'Pay Code Rules',
          path: 'rules',
          requireGetter: 'payrollEnabled',
          component: () => import('@/modules/payroll/PayCodeRuleList.vue')
        },
        {
          name: 'net-pay-settings',
          navIcon: 'DollarSign',
          label: 'Net Pay Settings',
          icon: 'dollar-sign',
          title: 'Net Pay Settings',
          path: 'netpay/settings',
          requireGetter: 'netPayEnabled',
          component: () => import('@/modules/payroll/NetPaySettingsForm.vue')
        },
        {
          name: 'net-pay-adjustment-codes',
          navIcon: 'Percent',
          label: 'Adjustment Codes',
          icon: 'percentage',
          title: 'Adjustment Codes',
          path: 'netpay/adjustment-codes',
          requireGetter: 'netPayEnabled',
          component: () => import('@/modules/payroll/NetPayAdjustmentCodeList.vue')
        },
        {
          name: 'net-pay-statutory-deductions',
          navIcon: 'Landmark',
          label: 'Statutory Deductions',
          icon: 'landmark',
          title: 'Statutory Deductions',
          path: 'netpay/statutory-deductions/:view?',
          props: true,
          requireGetter: 'netPayEnabled',
          component: () => import('@/modules/payroll/StatutoryDeductionList.vue')
        },
        {
          name: 'payroll-settings-index',
          path: '',
          redirect: { name: 'payroll-defaults' }
        }
      ]
    },
    {
      name: 'payroll-index',
      path: '',
      nav: false,
      // beforeEnter (unlike redirect) runs after the router has waited for app state to load, so this
      // reads accurate feature/permission state instead of racing it on a hard page load (e.g. new tab).
      beforeEnter: to => ({ name: getPayrollIndexRoute(store.state, store.getters), params: to.params })
    }
  ]
}
